/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */

'use strict';

module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/draft-js/lib/DraftJsDebugLogging.js
// module id = 1055
// module chunks = 0